export function buildBlockClass(block, modifiers) {
    return `${block} ${buildBlockModificationClass(block, modifiers)}`;
}

export function buildBlockModificationClass(block, modifiers = '') {
    return modifiers
        .split(' ')
        .map(modifier => `${block}--${modifier} `)
        .join(' ');
}
